import script from "./StepAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./StepAddress.vue?vue&type=script&setup=true&lang=js"

import "./StepAddress.vue?vue&type=style&index=0&id=22148228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22148228"]])

export default __exports__